export enum CorporateGovernanceProblemType {
  IndependentOverTwoPercent = 0,
  TwoCeosOrMore = 1,
  TwoChairmenOrMore = 2,
  AgeOver100OrUnder18 = 3,
  ShareholderOver100Percent = 4,
  FreeFloatUnderOrEqual5 = 5,
  MeetingAttendanceAverageOver100 = 6,
  IndependentOverTenure = 7,
  IndependentFormerExecutive = 8,
  FindFinancialExpert = 9,
  FindPoliticalConnection = 10
}
